export const Close = (props: React.ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none" {...props}>
      <path
        // eslint-disable-next-line max-len
        d="M1.3339 11.9928L0.0078125 10.6667L4.67448 6.00001L0.0078125 1.33335L1.3339 0.00726318L6.00056 4.67393L10.6672 0.00726318L11.9933 1.33335L7.32665 6.00001L11.9933 10.6667L10.6672 11.9928L6.00056 7.3261L1.3339 11.9928Z"
        fill="currentColor"
      />
    </svg>
  );
};
